import React, { Fragment } from 'react';
import { __, __n } from 'i18n-for-browser';
import { connect } from 'react-redux';

import GoBackButton from '../elements/GoBackButton';
import QuestionButton from '../elements/QuestionButton';
import ContentContainer from '../elements/ContentContainer';
import GameMaterials from '../elements/GameMaterials';
import Switch from '../elements/Switch';
import actions from '../../actions';
import { UPDATE_GHETTORADIO_HANDLING_ACTION, UPDATE_GHETTORADIO_LOCKED, UPDATE_GHETTORADIO_TIMER, UPDATE_GHETTORADIO_ACTIVE } from '../../actions/types';
import GroupGameScoreRow from '../elements/GroupGameScoreRow';
import GroupRow from '../elements/GroupRow';
import apiCall from '../apiCall';
import PopupTitle from "../elements/PopupTitle";
import { dispatchUnreadPopup, getPopupCurrentGame, getPopupDeviceDifficulty } from '../../helpers/popupHelper';
import PopUp from "../elements/PopUp";

const { setRoundState, submitGameScores, deactivateGame } = actions.gameState;
const { lockStepTwo, unlockStepTwo, toggleStepThree } = actions.ghettoRadio;

class Verdienen extends React.Component {
  static defaultProps = {
    desktop: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      gameScores: {},
      gameMaterials: [],
      submittingScores: false,
      showPopup: false,
      popupId: 0,
      popupCb: undefined,
    };
    this.gameId = parseInt(this.props.match.params.gameId, 10);
    this.deviceAndDifficulty = getPopupDeviceDifficulty(this.props.gameState.DefaultDifficultyId);
    this.curGame = getPopupCurrentGame(this.gameId);
  }

  componentDidMount() {
    const { props: { schoolClass, dispatch, project } } = this;
    const game = (schoolClass.SchoolClassGames.find(game => game.GameId === this.gameId)).Game;

    let checkGame = this.gameId;
    if (game.abbreviation) {
      checkGame = game.abbreviation.toLowerCase();
      this.curGame = getPopupCurrentGame(checkGame);
    }

    switch (checkGame) {
      case 2:
      case 'gr':
        //Ghettoradio
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'dhbvtghettoradio_T1' : 'dlbvtghettoradio_T1'), dispatch);
        break;
      case 3:
      case 'bo':
        //bonuspoints
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtextraopdrachten_T1' : 'mlbvtextraopdrachten_T1'), dispatch);
        break;
      case 4:
      case 'er':
        //escaperoute
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtescaperoute_T1' : 'mlbvtescaperoute_T1'), dispatch);
        break;
      case 5:
      case 'fq':
        //filmquiz
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtfilmquiz_T1' : 'mlbvtfilmquiz_T1'), dispatch);
        break;
      case 6:
      case 'dt':
        //detectivesspel
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtdetectives_T1' : 'mlbvtdetectives_T1'), dispatch);
        break;
      case 7:
      case 'mf':
        //moviefactory
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtmoviefactory_T1' : 'mlbvtmoviefactory_T1'), dispatch);
        break;
      case 8:
      case 'mc':
        //make a change
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtmakeachange_T1' : 'mlbvtmakeachange_T1'), dispatch);
        break;
      case 9:
      case 'ht':
        //Henna Tattoos
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvthennatattoos_T1' : 'mlbvthennatattoos_T1'), dispatch);
        break;
      case 'tc':
        //truecomics
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvttruecomics_T1' : 'mlbvttruecomics_T1'), dispatch);
        break;
      case 'wq':
        //wordquest
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtwordquest_T1' : 'mlbvtwordquest_T1'), dispatch);
        break;
      case 'vm':
        //votematch
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtvotematch_T1' : 'mlbvtvotematch_T1'), dispatch);
        break;
      case 'ga':
        //guessagain
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtguessagain_T1' : 'mlbvtguessagain_T1'), dispatch);
        break;
      case 'wa':
        //wanted
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtwanted_T1' : 'mlbvtwanted_T1'), dispatch);
        break;
      case 'tr':
        //totalrecall
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvttotalrecall_T1' : 'mlbvttotalrecall_T1'), dispatch);
        break;
      case 'fc':
        //factcheck
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtfactcheck_T1' : 'mlbvtfactcheck_T1'), dispatch);
        break;
      case 'rm':
        //readtheminds
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtreadtheminds_T1' : 'mlbvtreadtheminds_T1'), dispatch);
        break;
      case 'fq2':
        //filmquiz 2
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtfilmquiz2_T1' : 'mlbvtfilmquiz2_T1'), dispatch);
        break;
      case 'sa':
        //street art
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtstreetart_T1' : 'mlbvtstreetart_T1'), dispatch);
        break;
      case 'hl':
        // hotlist
        dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvthotlist_T1' : 'mlbvthotlist_T1'), dispatch);
        break;
      default:
        return;
    }
  }

  get game() {
    const { schoolClass } = this.props;
    if (Array.isArray(schoolClass.SchoolClassGames)) {
      const scg = schoolClass.SchoolClassGames.find(g => g.GameId === this.gameId);
      if (scg) return {
        ...scg.Game,
        SchoolClassGame: scg,
      };
    }
    return {};
  }

  get currentRound() {
    const { gameState } = this.props;
    return gameState.loaded ? gameState.roundData : {};
  }

  get isGameActive() {
    const { currentlyPlaying } = this.props.gameState;
    return currentlyPlaying === this.gameId;
  }

  get scoresSubmitted() {
    return (this.game.id === this.currentRound.GameId) && (this.currentRound.state === 'SCORE_SUBMITTED');
  }

  get allSubmitted() {
    const { Groups } = this.props.schoolClass;
    return Groups.every((grp) => {
      return Object.keys(this.state.gameScores).find(k => grp.id === parseInt(k, 10));
    });
  }

  componentWillMount() {
    this.fetchGeneralMaterials();
  }

  gameScoreUpdate = (groupId, value) => {
    const { gameScores } = this.state;
    gameScores[groupId] = JSON.parse(value);
    if (typeof gameScores[groupId] !== 'object') delete gameScores[groupId];
    this.setState({
      gameScores,
    });
  };

  toggleSubmittingScores = (value = !this.state.submittingScores) => {
    this.setState({
      submittingScores: value,
    });
  };

  submitGameScores = async (ev) => {
    ev.preventDefault();
    this.toggleSubmittingScores(true);
    if (this.allSubmitted && this.props.gameState.allowNewGame && !this.props.gameState.endOfGame && !this.state.submittingScores) {
      if (!this.isGameActive) {
        this.props.dispatch(setRoundState('PLAYING_GAME', this.gameId, this.state.gameScores));
        return;
      }
      this.props.dispatch(submitGameScores(this.state.gameScores, this.gameId, this.toggleSubmittingScores));
    }
  };

  loginAsGroup = (groupId) => {
    apiCall(`/user/${groupId}/loginAsGroup`, {}, 'POST')
      .then((access) => {
        if (this.game.softwareLocation && this.game.softwareLocation.startsWith('/') && !this.game.softwareLocation.startsWith('//')) {
          window.location.href = this.game.softwareLocation;
        } else {
          window.open(`${this.game.softwareLocation}?token=${access.token}&mentor=true`);
        }
      });
  };

  renderGameMaterials = () => {
    if (this.scoresSubmitted || !this.state.gameMaterials.length) return null;
    return (
      <div className="content-block content-block--small content-block--gamematerials">
        <div className={'title-container'}>
          <PopupTitle popupId={`${this.deviceAndDifficulty}bvt${this.curGame}_lesmateriaal`} tag={'h3'} />
        </div>
        <GameMaterials {...this.props} gameId={this.gameId} showPopup={(popupId, popupCb) => { this.setState({ popupId, popupCb, showPopup: true }); }} items={this.state.gameMaterials} />
        <div className="spacing-20" />
      </div>
    );
  };

  renderGRControls = (grGroups) => {
    const grGroup = grGroups.Groups[0].GhettoRadioGroup || {};
    let step2unlocked = false;
    let step3unlocked = true;
    if (grGroup.timerExpiresAt) {
      step2unlocked = new Date(grGroup.timerExpiresAt).getTime() <= new Date().getTime();
    }
    if (grGroup.locked) {
      step3unlocked = false;
    }
    return (
      <div>
        <ContentContainer className={this.isGameActive ? '' : 'disabled'}>
          <div className={'title-container'}>
            <PopupTitle popupId={`${this.deviceAndDifficulty}bvtghettoradio_lied`} tag={'p'} />
          </div>
          <Switch
            checked={step2unlocked}
            disabled={this.props.group.ghettoRadioHandlingAction === UPDATE_GHETTORADIO_TIMER}
            onChange={() => {
              if (!this.isGameActive) return;

              if (step2unlocked) {
                this.props.dispatch(lockStepTwo());
                return;
              }
              this.props.dispatch(unlockStepTwo());
            }}
          />
        </ContentContainer>
        <ContentContainer className={this.isGameActive ? '' : 'disabled'}>
          <div className={'title-container'}>
            <PopupTitle popupId={`${this.deviceAndDifficulty}bvtghettoradio_songtekst`} tag={'p'} />
          </div>
          <Switch
            checked={step3unlocked}
            disabled={this.props.group.ghettoRadioHandlingAction === UPDATE_GHETTORADIO_LOCKED}
            onChange={() => {
              if (!this.isGameActive) return;
              if (step3unlocked) {
                this.props.dispatch(toggleStepThree(1));
                return;
              }
              this.props.dispatch(toggleStepThree(0));
            }}
          />
        </ContentContainer>
      </div>
    );
  };

  renderGame = () => {
    const { gameState, group, desktop } = this.props;
    const grGroups = group.grGroups;
    const isGR = this.game.name.trim().replace(/ /g, '').toLowerCase() === 'ghettoradio';
    console.log(`${this.deviceAndDifficulty}bvt${this.curGame}_spelactiveren`, ' hier');
    return (
      <Fragment>
        <div className="content-block">
          <div className={'title-container'}>
            <PopupTitle popupId={`${this.deviceAndDifficulty}bvt${this.curGame}_spel`} tag={'h3'} />
          </div>
          {this.scoresSubmitted ? (
            <Fragment>
              {!desktop ? (
                <p className="scores-submitted-text">{__('sim_scores_voor_spel_zijn_ingevoerd')}</p>
              ) : null}
            </Fragment>
          ) : (
            this.game.softwareLocation || this.game.hasContent || this.game.seriousGamesSoftwareLocation ? (
              <div>
                <ContentContainer className={!gameState.allowNewGame || this.props.gameState.endOfGame ? 'disabled' : ''}>
                  <div className={'title-container'}>
                    <PopupTitle popupId={`${this.deviceAndDifficulty}bvt${this.curGame}_spelactiveren`} tag={'p'} />
                  </div>
                  <Switch
                    checked={this.isGameActive}
                    disabled={this.props.group.ghettoRadioHandlingAction === UPDATE_GHETTORADIO_ACTIVE}
                    onChange={() => {
                      if (!this.props.gameState.allowNewGame || this.props.gameState.endOfGame) {
                        return;
                      }
                      this.props.dispatch({ type: UPDATE_GHETTORADIO_HANDLING_ACTION, payload: UPDATE_GHETTORADIO_ACTIVE });
                      if (this.isGameActive) {
                        this.props.dispatch(deactivateGame());
                        return;
                      }
                      this.props.dispatch(setRoundState('PLAYING_GAME', this.game.id));
                    }}
                  />
                </ContentContainer>
                {isGR ? this.renderGRControls(grGroups) : null}
              </div>
            ) : null
          )}
          <div className="spacing-20" />
        </div>

      </Fragment>
    )
  };

  viewGamePerGroup = () => {
    const { schoolClass } = this.props;
    const isGR = this.game.name.trim().replace(/ /g, '').toLowerCase() === 'ghettoradio';
    if (isGR && !this.scoresSubmitted) {
      return (
        <div className="content-block">
          <div className={'title-container'}>
            <PopupTitle popupId={`${this.deviceAndDifficulty}bvtghettoradio_bekijkspel`} tag={'h3'} />
          </div>
          <div className={'group-rows-container'}>
            {
              schoolClass.Groups.map((group) => {
                return (
                  <GroupRow
                    key={group.id}
                    text={__(group.name)}
                    color={group.GroupTheme.color}
                    onClick={() => {
                      this.loginAsGroup(group.id);
                    }}
                  />
                )
              })
            }
          </div>
          <div className="spacing-20" />
        </div>
      )
    } else {
      return null;
    }
  };

  earnedGlobasPerGroup = () => {
    const { project, desktop } = this.props;
    const projectType = project.EducationProject.nameShort;
    const assignGameScoreOnce = this.game.assignGameScoreOnce[project.difficulty.toLowerCase()];
    if (projectType === 'GLXL') {
      return (
        <div className="content-block">
          {desktop && this.scoresSubmitted ? (
            <div className={'desktop-scores-submitted'}>
              <div className={'title-container'}>
                <h3>
                  <PopupTitle popupId={`${this.deviceAndDifficulty}bvt${this.curGame}_spel`} tag={'h3'} />
                </h3>
              </div>
              <p className="scores-submitted-text">{__('sim_scores_voor_spel_zijn_ingevoerd')}</p>
            </div>
          ) : null}

          <div className={'title-container'}>
            <PopupTitle popupId={`${this.deviceAndDifficulty}bvt${this.curGame}_verdiendeglobas`} tag={'h3'} />
          </div>

          <div className={'group-rows-container'}>
            {
              this.props.schoolClass.Groups.map((group) => {
                return (
                  <GroupGameScoreRow
                    key={group.id}
                    text={__(group.name)}
                    color={group.GroupTheme.color}
                    score={this.scoresSubmitted ? (group.Rounds[group.Rounds.length - 1] ? {
                      points: group.Rounds[group.Rounds.length - 1].earnedPoints,
                      globas: group.Rounds[group.Rounds.length - 1].earnedGlobas,
                    } : {}) : (this.state.gameScores[group.id] || {})}
                    editable={!this.scoresSubmitted}
                    gameScores={this.game.GameScores.filter((gs) => {
                      const { gameScores } = this.state;
                      const difficultyFilter = (gs.DifficultyId === this.props.project.DefaultDifficultyId);
                      if (!assignGameScoreOnce) {
                        return difficultyFilter;
                      }
                      const used = Object.keys(gameScores).find((key) => {
                        return gameScores[key].points === gs.points && gameScores[key].globas === gs.globas && parseInt(key, 10) !== group.id;
                      });
                      return difficultyFilter && !used;
                    })}
                    onChange={(value) => {
                      this.gameScoreUpdate(group.id, value);
                    }}
                  />
                )
              })
            }
          </div>
          {!this.scoresSubmitted ? (
            <button className={!this.props.gameState.allowNewGame || !this.allSubmitted || this.props.gameState.endOfGame || this.state.submittingScores ? 'disabled' : ''} onClick={this.submitGameScores}>
              <span>{__('sim_opslaan')}</span>
            </button>
          ) : null}
          <div className="spacing-20" />
        </div>
      )
    } else {
      return null;
    }
  };

  fetchGeneralMaterials = () => {
    const { schoolClass, project } = this.props;
    apiCall(`/generalMaterial/${schoolClass.LanguageId}/${project.DefaultDifficultyId}/${this.gameId}`)
      .then((gameMaterials) => {
        this.setState({ gameMaterials });
      });
  };

  goBack = () => {
    this.props.history.goBack();
  }

  goBackButtonHandler = () => {
    const showsGlobasAllocation = this.props.project.EducationProject.nameShort === 'GLXL';
    if (showsGlobasAllocation && this.scoresSubmitted === false && this.isGameActive) {
      this.setState({
        showPopup: true,
        popupId: `dhbm${this.curGame}_opslaan`,
      })
    } else {
      this.goBack();
    }
  }

  closePopupHandler = (answer) => {
    if (typeof this.state.popupCb === 'function') {
      this.state.popupCb(answer);
    }
    this.setState({
      showPopup: false,
      popupCb: undefined,
      popupId: null,
    })
    if (answer) {
      this.goBack();
    }
  }

  render() {
    const { group, desktop, project } = this.props;
    const renderViewGamePerGroup = this.viewGamePerGroup();
    const isGLXL = project.EducationProject.nameShort === 'GLXL';
    const nonAppGame = !this.game.hasContent && !this.game.contentLocation && !this.game.seriousGamesSoftwareLocation;
    let mainClassNames = 'portal-verdienen ' + (desktop ? 'portal-home verdelen-desktop darkBckg' : '') + ((this.scoresSubmitted || nonAppGame) && desktop ? ' desktop-single' : '');
    if (!isGLXL && !renderViewGamePerGroup) {
      mainClassNames += ' overige-projecten';
    }
    if (!group.grGroups.loaded) return null;
    return (
      <div className={mainClassNames}>
        {this.state.showPopup ? (
          <PopUp id={this.state.popupId} closePopUpClick={(res) => { this.closePopupHandler(res) }} />
        ) : null}
        <div className={`container list-item-container ${(this.scoresSubmitted || nonAppGame ? ' small-desktop-container' : '')}`}>
          <div className={'title-block'}>
            <GoBackButton customHandler={this.goBackButtonHandler} history={this.props.history} />
            {isGLXL ? (
              <span>
                <h3>
                  <QuestionButton popupId={`${this.deviceAndDifficulty}bvt${this.curGame}_1`}>{this.game.name}</QuestionButton>
                </h3>
                <p>{__('sim_globas_verdienen')}</p>
              </span>
            ) : (
              <span>
                <h3>
                  {__n('sim_spel', 0)}
                </h3>
                <p>{this.game.name}</p>
              </span>
            )}
          </div>
          {desktop ?
            nonAppGame ? (
              <div className="column-portal" style={{ marginRight: 0, display: 'initial' }}>
                {this.renderGameMaterials()}
                {this.earnedGlobasPerGroup()}
              </div>
            ) : (
              renderViewGamePerGroup ? (
                <Fragment>
                  <div className="column-portal column-portal-row" style={{ marginTop: '20px !important' }}>
                    {this.renderGame()}
                    {this.renderGameMaterials()}
                  </div>
                  <div className="column-portal column-portal-row">
                    {this.viewGamePerGroup()}
                    {this.earnedGlobasPerGroup()}
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <div className="column-portal">
                    {this.renderGame()}
                    {this.renderGameMaterials()}
                  </div>
                  <div className="column-portal">
                    {this.viewGamePerGroup()}
                    {this.earnedGlobasPerGroup()}
                  </div>
                </Fragment>
              )
            )
            : (
              nonAppGame ? (
                <div className="column-portal">
                  {this.renderGameMaterials()}
                  {this.earnedGlobasPerGroup()}
                </div>
              ) : (
                <div className="column-portal">
                  {this.renderGame()}
                  {this.renderGameMaterials()}
                  {this.viewGamePerGroup()}
                  {this.earnedGlobasPerGroup()}
                </div>
              )
            )}
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  project: state.project,
  group: state.group,
  schoolClass: state.schoolClass,
  gameState: state.gameState,
}))(Verdienen);



// WEBPACK FOOTER //
// ./src/components/routes/Verdienen.js